import tw from "twin.macro"

export const BaseGrid = tw.div`
  grid grid-cols-1
  w-full max-w-md
  desktop:grid-cols-3
  laptop:(grid-cols-2 max-w-container-large)
`

export const Wrapper = tw.div`
  flex flex-row
  gap-8
  w-full max-w-md
  laptop:(max-w-container-large)
`

export const CardGrid = tw(BaseGrid)`
  col-span-4
  gap-4
  my-4
  h-fit
  flex-1
  tablet:gap-8
`

export const NoResultsWrapper = tw.div`
  flex flex-col items-center justify-center
  text-center
  col-span-1
  desktop:(col-span-2 row-span-1)
  desktop-xl:(col-span-3 row-span-2)
`
